import EventBus from "../../bus/events";

export const accounts = {
    state: {
        accounts: {},
        sharedAccounts: {},
        accountsErrors: [],
        accountsLoaded: 0,
        accountCreated: 0
    },
    actions: {
        getBillingAccounts({ commit }) {
            commit('setProductsLoaded', 1);
            axios.get('/accounts')
                .then((response) => {
                    commit('setAccounts', response.data);
                    commit('setAccountsLoaded', 2);
                }).catch(() => {
                    commit('setAccountsLoaded', 3);
                });
        },
        getSharedBillingAccounts({ commit }) {
            commit('setProductsLoaded', 1);
            axios.get('/accounts/shared')
                .then((response) => {
                    commit('setSharedAccounts', response.data);
                    commit('setAccountsLoaded', 2);
                }).catch(() => {
                    commit('setAccountsLoaded', 3);
                });
        },
        createAccount({ commit, dispatch }, data) {
            commit('setAccountCreated', 1);
            axios.post('/accounts', data)
                .then((response) => {
                    EventBus.$emit('billing-account-created', {
                        account: response.data.data
                    });
                    commit('setAccountsErrors', []);
                    dispatch('getBillingAccounts')
                }).catch((error) => {
                    commit('setAccountCreated', 3);
                    if (error.response && error.response.status === 422) {
                        commit('setAccountsErrors', error.response.data.errors);
                    }
                });
        },

        transferCredits({ commit, dispatch }, data) {
            axios.post(`billing/accounts/${data.source}/transfer`, data)
                .then((response) => {
                    EventBus.$emit('billing-account-credited', {
                        account: response.data.data
                    });
                    commit('setAccountsErrors', []);
                    dispatch('getBillingAccounts')
                }).catch((error) => {
                    if (error.response && error.response.status === 422) {
                        commit('setAccountsErrors', error.response.data.errors);
                    }
                });
        }

    },
    mutations: {

        setAccounts(state, accounts) {
            state.accounts = accounts;
        },

        setSharedAccounts(state, accounts) {
            state.sharedAccounts = accounts;
        },

        setAccountsLoaded(state, status) {
            state.accountsLoaded = status;
        },

        setAccountCreated(state, status) {
            state.accountCreated = status;
        },

        setAccountsErrors(state, status) {
            state.accountsErrors = status;
        }
    },
    /*
      Defines the getters used by the module
    */
    getters: {

        getAccountsErrors(state) {
            return state.accountsErrors;
        },
        /*
          Returns the billing accounts load status.
        */
        getAccountLoaded(state) {
            return state.accountsLoaded;
        },

        /*
          Returns the billing account account status.
        */
        getAccountCreated(state) {
            return state.accountCreated;
        },

        /*
          Returns the the billing accounts.
        */
        getAccounts(state) {
            return state.accounts;
        },

        /*
          Returns the shared billing accounts.
        */
        getSharedAccounts(state) {
            return state.sharedAccounts;
        }
    }
};
